<div class="template-block-main">
    <div class="title-block d-flex justify-content-between align-items-start w-100 bg-white h-100">
        <div class="flexbox-column gap-2 h-100">
            <mat-drawer-container class="countable-drawer-new firm-settings-section">
                <mat-drawer
                    #drawer
                    opened
                    appResizableDrawer
                    [minWidth]="300"
                    [maxWidth]="500"
                    (resizeEvent)="onResizePanelEnd($event)"
                >
                    <div
                        #leftPanel
                        class="templates-left d-flex flex-column gap-10 template-block-main justify-content-start"
                        [ngClass]="{ mandatedisable: mfaMandatory() }"
                        style="min-width: 300px"
                    >
                        <div
                            class="page-title p-20 d-flex flex-row gap-12 w-100 setting-left-side-bar align-items-center"
                        >
                            <span class="badge br-28 bg-gray-1">
                                <button mat-button class="button-text" title="Close" (click)="closeWindow()">
                                    <i class="fa-regular fa-arrow-left"></i>
                                </button>
                            </span>

                            <h3 class="title">Settings</h3>
                        </div>
                        <mat-accordion class="templates-list w-100 p-3 pt-0 left-side-menu">
                            <mat-list role="list" class="templates-list-items">
                                <mat-list-item role="listItem" class="setting-left-menu">
                                    <button
                                        class="list-item-content cust-border nav-item setting-left-menu-btn gap-8"
                                        title="My Account"
                                        (click)="activeSection.set('myAccount')"
                                        [ngClass]="{ disabled: !billing || firm?.isAccountLockedForBilling, active: activeSection() === 'myAccount' }"
                                    >
                                        <span class="nav-icon bg-primary-badge-bg"
                                            ><i class="fa-regular fa-circle-user"></i
                                        ></span>
                                        My Account
                                    </button>
                                </mat-list-item>
                            </mat-list>

                            <mat-list role="list" class="templates-list-items">
                                <mat-list-item
                                    role="listItem"
                                    [disabled]="!acl?.hasPlatformExport"
                                    class="setting-left-menu"
                                >
                                    <button
                                        class="list-item-content cust-border nav-item setting-left-menu-btn gap-8"
                                        title="Letterhead & Signature"
                                        (click)="activeSection.set('letterheadSignature')"
                                        [ngClass]="{
                                            disabled:
                                                !billing || firm?.isAccountLockedForBilling || !acl?.hasPlatformExport, active: activeSection() === 'letterheadSignature'
                                        }"
                                    >
                                        <span class="nav-icon bg-primary-badge-bg"
                                            ><i class="fa-regular fa-signature"></i
                                        ></span>
                                        Letterhead & Signature
                                    </button>
                                </mat-list-item>
                            </mat-list>

                            <mat-list role="list" class="templates-list-items">
                                <mat-list-item
                                    role="listItem"
                                    [disabled]="!acl?.hasPlatformExport"
                                    class="setting-left-menu"
                                >
                                    <button
                                        class="list-item-content cust-border nav-item setting-left-menu-btn gap-8"
                                        title="Notifications"
                                        (click)="activeSection.set('notifications')"
                                        [ngClass]="{
                                            disabled:
                                                !billing || firm?.isAccountLockedForBilling || !acl?.hasPlatformExport, active: activeSection() === 'notifications'
                                        }"
                                    >
                                        <span class="nav-icon bg-primary-badge-bg"
                                            ><i class="fa-regular fa-bell"></i
                                        ></span>
                                        Notifications
                                    </button>
                                </mat-list-item>
                            </mat-list>

                            @if(userDetail && userDetail.useraccesstypeid === 2){
                            <mat-list role="list" class="templates-list-items">
                                <mat-list-item
                                    role="listItem"
                                    [disabled]="!acl?.hasPlatformExport"
                                    class="setting-left-menu"
                                >
                                    <button
                                        class="list-item-content cust-border nav-item setting-left-menu-btn gap-8"
                                        title="User & Access"
                                        (click)="activeSection.set('userAccess')"
                                        [ngClass]="{
                                            disabled:
                                                !billing || firm?.isAccountLockedForBilling || !acl?.hasPlatformExport, active: activeSection() === 'userAccess'
                                        }"
                                    >
                                        <span class="nav-icon bg-primary-badge-bg"
                                            ><i class="fa-regular fa-shield-keyhole"></i
                                        ></span>
                                        User & Access
                                    </button>
                                </mat-list-item>
                            </mat-list>
                            }

                          
                            <mat-list role="list" class="templates-list-items">
                                <mat-list-item
                                    role="listItem"
                                    [disabled]="!acl?.hasPlatformExport"
                                    class="setting-left-menu"
                                >
                                    <button
                                        class="list-item-content cust-border nav-item setting-left-menu-btn gap-8"
                                        title="Privacy & Security"
                                        (click)="activeSection.set('privacySecurity')"
                                        [ngClass]="{
                                            disabled:
                                                !billing || firm?.isAccountLockedForBilling || !acl?.hasPlatformExport, active: activeSection() === 'privacySecurity'
                                        }"
                                    >
                                        <span class="nav-icon bg-primary-badge-bg"
                                            ><i class="fa-regular fa-shield-check"></i
                                        ></span>
                                        Privacy & Security
                                    </button>
                                </mat-list-item>
                            </mat-list>
                            <mat-list role="list" class="templates-list-items">
                                <mat-list-item
                                    role="listItem"
                                    [disabled]="!acl?.hasPlatformExport"
                                    class="setting-left-menu"
                                >
                                    <button
                                        class="list-item-content cust-border nav-item setting-left-menu-btn gap-8"
                                        title="Export Data"
                                        (click)="activeSection.set('exportData')"
                                        [ngClass]="{
                                            disabled:
                                                !billing || firm?.isAccountLockedForBilling || !acl?.hasPlatformExport, active: activeSection() === 'exportData'
                                        }"
                                    >
                                        <span class="nav-icon bg-primary-badge-bg"
                                            ><i class="fa-regular fa-file-export"></i
                                        ></span>
                                        Export Data
                                    </button>
                                </mat-list-item>
                            </mat-list>
                        </mat-accordion>
                    </div>
                </mat-drawer>

                <mat-drawer-content class="overflow-hidden">
                    <div #togglePanel class="toogle-button-block button-block-left">
                        <button mat-button class="button-small-icon toogle-button" (click)="drawer.toggle()"></button>
                        <div class="toogle-content setting-toggle">
                            <h6 class="title">Settings</h6>
                        </div>
                    </div>

                    <div
                        #centerSection
                        class="page-wraper flex-1 h-100 overflow-x-auto"
                        id="parentDiv"
                        [ngClass]="{ 'user-change-password': isChangePassword() }"
                        style="scroll-behavior: smooth"
                    >
                        @if (activeSection() === 'myAccount') {
                        <app-user-profile [selectedTabIndex]="tabIndex"></app-user-profile>
                        } 
                        @if (activeSection() === 'letterheadSignature') {
                        <app-components></app-components>
                        } 
                        @if (activeSection() === 'notifications') {
                        <app-user-notifications></app-user-notifications>
                        } 
                        @if (activeSection() === 'userAccess') {
                        <app-user-teamaccess (toggleSettingsOverlay)="onOverlayChange($event)"></app-user-teamaccess>
                        }                      
                        @if (activeSection() === 'privacySecurity') {
                        <app-privacy-security></app-privacy-security>
                        } 
                        @if (activeSection() === 'exportData') {
                        <app-user-export-data></app-user-export-data>
                        } 
                        @if (!activeSection()) {
                        <div>Select a setting from the menu</div>
                        }
                    </div>
                </mat-drawer-content>
            </mat-drawer-container>
        </div>
    </div>
</div>
